import { useState } from "react";
import { Link } from "react-router-dom";
import isMobile from '../utils/checkUserAgent';
import videoIsLandscape from '../utils/checkVideoOrientation';
import ReactPlayer from 'react-player';

function HomeItem({ item }) {

  const [isPlaying, setIsPlaying] = useState(false);

  const { linkTo, image, video, title, description, label } = item;
  
  const landscape = video ? videoIsLandscape(video) : false;

  const mobile = isMobile();

  return (
    <Link to={linkTo} className="gridItem" data-mobile={mobile}>
      <div className="aspectRatioBox"
        onMouseOver={!mobile ? () => setIsPlaying(true) : undefined}
        onMouseOut={!mobile ? () => setIsPlaying(false) : undefined}
      >
        <div className="mediaContainer">
          <img src={image} className={video ? "blur" : undefined} />
          {video && 
            <div className="mediaItem" data-landscape={landscape}>
              <ReactPlayer 
                url={video} 
                playing={isPlaying}
                loop={true}
                width={!landscape ? '100%' : 'auto'}
                height={!landscape ? 'auto' : '100%'}
                playsinline={true}
                muted={true}
              />
            </div>
          }
        </div>
      </div>
      <h3>{title}</h3>
      <p className="family light">{description}</p>
      <div className="label">{label}</div>
    </Link>
  )
}

export default HomeItem;